var _sodipodiNamedview, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoItemsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "539.74304pt",
    height: "486.41058pt",
    viewBox: "0 0 539.74304 486.41058",
    id: "svg304",
    sodipodiDocname: "noun-no-item-4440881.svg",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview306",
    pagecolor: "#505050",
    bordercolor: "#eeeeee",
    borderopacity: 1,
    inkscapeShowpageshadow: 0,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0,
    inkscapeDeskcolor: "#505050",
    "inkscapeDocument-units": "pt",
    showgrid: "false"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs232"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g302",
    "inkscapeExport-filename": "g302.svg",
    "inkscapeExport-xdpi": 96,
    "inkscapeExport-ydpi": 96,
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    },
    transform: "translate(-80.112967,-36.835998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 459.2,98.086 C 441.891,80.777 418.981,71.274 394.462,71.274 c -24.52,0 -47.43,9.5039 -64.656,26.812 -35.637,35.637 -35.637,93.758 0,129.39 17.309,17.309 40.219,26.812 64.656,26.812 24.437,0 47.43,-9.5039 64.738,-26.812 35.637,-35.723 35.637,-93.758 0,-129.39 z m -8.9922,120.4 c -14.848,14.848 -34.617,23.078 -55.66,23.078 -21.043,0 -40.812,-8.2305 -55.66,-23.078 -30.715,-30.715 -30.715,-80.691 0,-111.41 14.848,-14.848 34.617,-23.078 55.66,-23.078 21.043,0 40.812,8.2305 55.66,23.078 30.715,30.715 30.715,80.691 0,111.41 z",
    id: "path234",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 609.8,331.84 -76.023,-76.023 c -7.043,-7.043 -16.887,-10.438 -26.727,-9.332 L 496.359,235.794 C 531.488,186.837 527.16,118.114 483.207,74.074 459.535,50.402 428.055,37.336 394.539,37.336 c -33.516,0 -64.992,13.066 -88.668,36.738 -48.871,48.871 -48.871,128.46 0,177.42 24.438,24.438 56.594,36.656 88.668,36.656 25.625,0 51.25,-7.9766 72.969,-23.504 l 10.691,10.691 c -1.1016,9.8438 2.207,19.684 9.332,26.727 l 76.023,76.023 c 6.1953,6.1953 14.426,9.5859 23.164,9.5859 8.7383,0 16.969,-3.3945 23.164,-9.5859 C 622.53,365.36 622.53,344.571 609.8,331.845 Z M 314.78,242.41 c -21.297,-21.297 -33.008,-49.551 -33.008,-79.672 0,-30.121 11.711,-58.375 33.008,-79.672 21.297,-21.301 49.637,-33.008 79.672,-33.008 30.035,0 58.375,11.711 79.672,33.008 21.297,21.297 33.008,49.551 33.008,79.672 0,30.121 -11.711,58.375 -33.008,79.672 -43.867,43.949 -115.39,43.949 -159.34,0 z M 600.8,369.09 c -7.8047,7.8047 -20.449,7.8047 -28.254,0 l -76.023,-76.023 c -4.8359,-4.8359 -6.7891,-11.793 -5.3438,-18.582 0.50781,-2.1211 -0.16797,-4.3281 -1.6953,-5.8555 l -12.047,-12.047 c 1.9531,-1.6953 3.9023,-3.3086 5.6836,-5.1758 1.7813,-1.8672 3.4805,-3.8164 5.1758,-5.6836 l 12.047,12.047 c 1.5273,1.5273 3.7344,2.207 5.8555,1.6953 6.7891,-1.5273 13.66,0.42578 18.582,5.3438 l 76.023,76.023 c 3.8164,3.8164 5.8555,8.8242 5.8555,14.168 -0.004,5.3516 -2.043,10.273 -5.8594,14.09 z",
    id: "path236",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 218.99,344.48 56.426,-67.113 56.426,67.113 c 1.1875,1.4414 2.9688,2.2891 4.8359,2.2891 h 162.14 c 3.4805,0 6.3633,-2.8867 6.3633,-6.3633 0,-3.4805 -2.8867,-6.3633 -6.3633,-6.3633 h -159.18 l -50.57,-60.156 h 6.0234 c 3.4805,0 6.3633,-2.8867 6.3633,-6.3633 0,-3.4805 -2.8867,-6.3633 -6.3633,-6.3633 h -146.87 c -1.8672,0 -3.6484,0.84766 -4.8359,2.2891 l -61.262,72.887 c -1.6133,1.8672 -1.9531,4.4961 -0.93359,6.7891 1.0195,2.2031 3.3086,3.6484 5.7695,3.6484 h 127.19 c 1.8672,0 3.6484,-0.85156 4.8359,-2.293 z M 100.63,334.042 151.2,273.886 h 110.56 l -50.57,60.156 z",
    id: "path238",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.89,455.3 h -66.52 c -3.4805,0 -6.3633,2.8867 -6.3633,6.3633 0,3.4805 2.8867,6.3633 6.3633,6.3633 h 66.52 c 3.4805,0 6.3633,-2.8867 6.3633,-6.3633 0,-3.4766 -2.8828,-6.3633 -6.3633,-6.3633 z",
    id: "path240",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 371.89,479.99 h -66.52 c -3.4805,0 -6.3633,2.8867 -6.3633,6.3633 0,3.4805 2.8867,6.3633 6.3633,6.3633 h 66.52 c 3.4805,0 6.3633,-2.8867 6.3633,-6.3633 0,-3.4805 -2.8828,-6.3633 -6.3633,-6.3633 z",
    id: "path242",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 424.41,132.79 c -2.4609,-2.4609 -6.5352,-2.4609 -8.9922,0 l -20.957,20.957 -20.957,-20.957 c -2.4609,-2.4609 -6.5352,-2.4609 -8.9922,0 -2.4609,2.4609 -2.4609,6.5352 0,8.9922 l 20.957,20.957 -20.957,20.957 c -2.4609,2.4609 -2.4609,6.5352 0,8.9922 1.2734,1.2734 2.8867,1.8672 4.4961,1.8672 1.6133,0 3.2227,-0.59375 4.4961,-1.8672 l 20.957,-20.957 20.957,20.957 c 1.2734,1.2734 2.8867,1.8672 4.4961,1.8672 1.6133,0 3.2227,-0.59375 4.4961,-1.8672 2.4609,-2.4609 2.4609,-6.5352 0,-8.9922 l -20.957,-20.957 20.957,-20.957 c 2.543,-2.4609 2.543,-6.5312 0,-8.9922 z",
    id: "path244",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 501.29,359.5 c -3.4805,0 -6.3633,2.8867 -6.3633,6.3633 v 144.07 h -213.14 v -202.96 c 0,-3.4805 -2.8867,-6.3633 -6.3633,-6.3633 -3.4805,0 -6.3633,2.8867 -6.3633,6.3633 v 202.96 h -114.46 v -144.07 c 0,-3.4805 -2.8867,-6.3633 -6.3633,-6.3633 -3.4805,0 -6.3633,2.8867 -6.3633,6.3633 v 150.52 c 0,3.4805 2.8867,6.3633 6.3633,6.3633 h 352.97 c 3.4805,0 6.3633,-2.8867 6.3633,-6.3633 v -150.52 c 0.0859,-3.5625 -2.8008,-6.3633 -6.2773,-6.3633 z",
    id: "path246",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "#ffffff",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoItemsIcon);
export default __webpack_public_path__ + "static/media/no-items-icon.13a92dec7fba8d4c13bd9eec1fd8d85a.svg";
export { ForwardRef as ReactComponent };